import React from 'react';
import { RichText } from 'prismic-reactjs';
import { get } from 'lodash';

export default function LLRChartSlice(slice) {
  const backgroundStyle = {
    backgroundColor: get(slice, 'primary.background_color'),
    color: get(slice, 'primary.text_color')
  };

  return (
    <section className="llr-chart-slice cool-margin" style={backgroundStyle}>
      <div className="llr-wrapper">
        <div className="copy">
          <RichText render={get(slice, 'primary.copy')} />
        </div>
        <div className="img">
          <img src={get(slice, 'primary.image.url')} alt={get(slice, 'primary.image.alt')} />
        </div>
      </div>
    </section>
  );
}
